import { useState } from 'react';
import { Container } from '@mui/material';
import '../../css/GlobalStyles.css';

import Page from '../../components/Page';
import DashboardNavbar from '../../layouts/dashboard/DashboardNavbar';
import DashboardSidebar from '../../layouts/dashboard/DashboardSidebar';
import BranchContentCard from '../components/BranchContentCard';


export default function BranchManagement() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <Page title="Branch Management">
      <DashboardNavbar onOpenSidebar={() => setSidebarOpen(true)} />
      <DashboardSidebar
        isOpenSidebar={sidebarOpen}
        onCloseSidebar={() => setSidebarOpen(false)}
      />

      <Container maxWidth="false">
        <BranchContentCard />
      </Container>
    </Page>
  );
}
